<template>

    <v-container
        style="height:100%;"
        fluid
        class="collector-bg"
        :style="{
            'background-color': bg_color,
            'background-image': `url(${bg_img_url});`
        }"
        :key="container_key"
    >
        <v-card
            elevation="0"
            class="app-container"
            v-if="!is_send"
        >
            <v-card
                v-if="title_html"
                elevation="0"
                class="title-container mt-4 mb-4"
                :style="{
                    'background-color':title_bg_color
                }"
            >
                <div v-html="title_html"></div>
            </v-card>


            <div class="d-flex align-center justify-center flex-column pt-3 pb-3  pl-2 pr-2" 
                style="background-color:#FFFFFF;"
            >
            <v-form
                ref="form"
                class="mt-4"
                style="width:100%;"
                lazy-validation v-on:submit.prevent
            >

                <div
                    class="mb-4"
                >
                    <h3
                        style="text-align:left;"
                        :style="{
                            'color': theme_color
                        }"
                        class="mb-2"
                    >
                        姓名
                    </h3>
                    <v-row
                    >
                        <v-col
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            class="pb-0"
                        >
                            <v-text-field
                                v-model="data.name"
                                dense
                                outlined
                                placeholder="王小明"
                                :maxlength="30"
                                :rules="[$utils.field_rules.required]"
                            ></v-text-field>
                        </v-col>

                    </v-row>
                </div>

                <div
                    class="mb-4"
                >
                    <h3
                        style="text-align:left;"
                        :style="{
                            'color': theme_color
                        }"
                        class="mb-2 pl-0 pr-0"
                    >
                        信箱
                    </h3>
                    <v-row
                    >
                        <v-col
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            class="pb-0"
                        >
                            <v-text-field
                                ref="email_input"
                                v-model="data.email"
                                dense
                                outlined
                                placeholder="abc@example.com"
                                :rules="[$utils.field_rules.email, $utils.field_rules.required]"
                            ></v-text-field>
                        </v-col>

                    </v-row>
                </div>  
            </v-form>

                <div
                    class="tab-container mb-2"
                >
                    <v-tabs
                        :color="theme_color"
                        :background-color="'transparent'"
                        v-model="tab"
                        dense
                    >
                        <v-tab
                            dense
                            :style="{
                                'color': theme_color
                            }"
                        >
                            電子發票
                        </v-tab>
                        <v-tab
                            dense
                            :style="{
                                'color': theme_color
                            }"
                        >
                            傳統發票
                        </v-tab>
                    </v-tabs>
                </div>

                <v-tabs-items v-model="tab"
                    style="width:100%;"
                >
                    <v-tab-item
                        :transition="false"
                    >

                        <!-- {{input_method}} -->
                        <v-btn-toggle
                            v-model="input_method"
                            mandatory
                            color="primary" 
                            class="d-flex flex-row mt-3 pl-4 pr-4"
                            rounded
                        >
                            <v-btn
                                small
                                class="flex-grow-1"
                            >
                                <v-icon small class="mr-3">mdi-scan-helper</v-icon>
                                掃描輸入
                            </v-btn>
                            <v-btn
                                small
                                class="flex-grow-1"
                            >
                                <v-icon small class="mr-3">mdi-pencil</v-icon>
                                手動輸入
                            </v-btn>
                        </v-btn-toggle>
                        <div
                            @click="submit"
                            style="position:relative;"
                        >
                            <v-overlay
                                :absolute="absolute"
                                :value="overlay"
                                :opacity="0"
                            >

                            </v-overlay>
                            <InvoiceScan
                                ref="invoice_scan"
                                v-if="input_method === 0"
                                :setting="{
                                    theme_color: theme_color
                                }"
                                @submit="scanCallback"
                            >

                            </InvoiceScan>
                        </div>


                        <InvoiceForm 
                            ref="invoice_form_1"
                            v-if="input_method === 1"
                            :setting="{
                                tab: tab,
                                theme_color: theme_color,
                                data: data,
                                value_method: value_method,
                            }"
                        >
                        </InvoiceForm>

                    </v-tab-item>

                    <v-tab-item
                     :transition="false"
                    >
                        <InvoiceForm 
                            ref="invoice_form_2"
                            :setting="{
                                tab: tab,
                                theme_color: theme_color,
                                data: data,
                                value_method: value_method,
                            }"
                        >
                        </InvoiceForm>
                    </v-tab-item>
                </v-tabs-items>

                <div 
                    class="d-flex align-center justify-center flex-column mt-1 mb-1" 
                >
                    <v-btn 
                        rounded
                        large
                        :color="theme_color"
                        class="pl-10 pr-10 white--text"
                        @click="submit"
                    >
                        {{btn_text}}
                    </v-btn>
                </div>
            </div>
        </v-card>

        <v-card
            v-else
            style="width:100%;"
        >

            <v-card-text
                class="d-flex flex-column align-center justify-center"
                style="height:100%;"
            >

                <v-icon
                    v-if="is_send_success"
                    color="success"
                    x-large
                    
                >
                    mdi-check-bold
                </v-icon>

                <v-icon
                    v-else
                    x-large
                    color="error"
                >
                    mdi-alert-circle-outline
                </v-icon>

                <div
                    v-if="is_send_success"
                    class="invoice-title mt-4 mb-4"
                >
                    登錄成功
                </div>
                <div v-else
                    class="invoice-title mt-4 mb-4"
                >
                    登錄失敗
                </div>   

                <div
                    class="mb-4"
                    v-if="!is_send_success"
                >
                    {{send_message}}    
                </div>                 

                <v-btn
                    :color="theme_color"
                    class="white--text"
                    @click="reDo"
                >   
                    {{ is_send_success ? '再登錄一張' : '重新登錄'}}
                </v-btn>

            </v-card-text> 
        </v-card>

        
        <template v-if="is_edit !== 'true'">
            <v-overlay
            v-if="(login_required && is_login === false && is_click === false) || is_expired === true"
            :absolute="absolute"
            :value="overlay"
            :opacity="opacity"
            @click="clickOverlay"
            >
            </v-overlay>

            <v-dialog
                v-model="dialog"
                width="700"
                @click:outside="closeDialog"
            >
                <v-card v-if="!is_expired">
                    <v-card-title 
                        class="text-h5"
                        :style="{
                            'color': theme_color
                        }"
                    >
                        活動提示
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="closeDialog"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <div>需要登入會員</div>
                    </v-card-text>
                    <v-card-actions
                        class="d-flex align-center justify-center"
                    >
                        <v-btn
                            :color="theme_color"
                            @click="requestUserInfo(true)"
                            class="white--text"
                        >
                            登入會員
                        </v-btn>
                    </v-card-actions>
                </v-card>

                <v-card v-else>
                    <v-card-title 
                        class="text-h5"
                        :style="{
                            'color': theme_color
                        }"
                    >
                        活動提示
                        <v-spacer></v-spacer>
                        <v-btn
                            icon
                            @click="closeDialog"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <div>活動尚未開始</div>
                    </v-card-text>
                    <v-card-actions
                        class="d-flex align-center justify-center"
                    >
                        <v-btn
                            :color="theme_color"
                            @click="closeDialog"
                            class="white--text"
                        >
                            關閉
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

    </v-container>

</template>

<script>
import {
    apiSendInvoice,
    apiSendInvoiceData,
    apiGetInvoiceCollector,
} from '@/api/urlview.js'
import InvoiceForm from './InvoiceForm.vue';
import InvoiceScan from './InvoiceScan.vue'
    export default {
        name: 'InvoiceCollectorPublicIframe',
        props: {
        },
        components: {
            InvoiceForm, InvoiceScan
        },
        data: function(){
            return {
                tab: 0,
                bg_color: '#e3a7d6',
                bg_img_url: '',
                title_html: '<p>內文</p>',
                title_bg_color: 'rgba(255,255,255,0.6)',
                theme_color: '#af2c88',
                input_method: 0,
                value_method: 'cost',
                data: {
                    scan: {},
                    prefix: '',
                    number: '',
                    create_at: '',
                    random_number: '',
                    name: '',
                    email: '',
                    customer_id: '',
                    value: 0,
                    items: [
                        {
                            "quantity": "",
                            "name": "",
                            "per_price": ""
                        }
                    ],
                },
                init_data:{
                    scan: {},
                    prefix: '',
                    number: '',
                    create_at: '',
                    random_number: '',
                    name: '',
                    email: '',
                    customer_id: '',
                    value: 0,
                    items: [
                        {
                            "quantity": "",
                            "name": "",
                            "per_price": ""
                        }
                    ],
                },
                btn_text: '登錄發票',
                login_modal_title: '活動登入',
                login_modal_html: '<div>要登入要登入</div>',
                login_required: false,
                is_click: false,
                is_login: false,
                is_expired: false,
                is_edit: false,
                absolute: true,
                opacity: 0,
                overlay: true,
                dialog: false,
                container_key: 0,
                save_fields: [
                    'name', 'login_required', 'value_method',
                    'selected_size_item', 'bg_src',
                    'frame_width', 'frame_height',
                    'bg_color', 'theme_color',
                    'title_html', 'pixel_event', 'custom_event'
                ],
                container_id: '',
                is_send: false,
                is_send_success: false,
                send_message: '',
            }
        }, 
        created: async function(){

        },
        mounted: async function(){
            try {
                let id = this.$route.query.id
                let is_edit = this.$route.query.is_edit
                if (id) {
                    await this.getData(id)
                }
                this.is_edit = is_edit
                this.container_id = this.$route.query.container_id
            } catch (error) {
                console.log('error',error)
            }


            if (this.is_edit === 'true') {
                window.addEventListener('message', this.getIframeCallback)
                this.requestUserInfo(false)
            }
            else {
                if (!this.is_expired) {
                    window.addEventListener('message', this.getIframeCallback)
                    this.requestUserInfo(false)
                }
            }


        },
        methods: {
            async getData(id){
                try {
                    let result = await apiGetInvoiceCollector(id)
                    let column = JSON.parse(result.data.add_column)
                    console.log('column',column)
                    console.log('result',result.data)
                    this.start_at = new Date(result.data.start_at)
                    this.end_at = new Date(result.data.end_at)
                    let now = new Date().getTime()
                    if (now < this.start_at.getTime() || now > this.end_at.getTime()) {
                        this.is_expired = true
                        console.log('is_expired', this.is_expired)
                    }
                    
                    this.save_fields.forEach((field) => {
                        if (column[field] !== undefined && column[field] !== null){
                            this[field] = column[field]
                        }
                    })

                } catch (error) {
					this.$root.vtoast.show({
						message: `取得設定檔失敗，原因: ${error}`
					})
                }
            },
            handleInputPrefix(){
                console.log(this.data.prefix)
                if (this.data.prefix.length >= 2) {
                    this.$refs.number_input.focus();
                }
            },
            handleInputNumber(){

            },
            handleInputDate(){

            },
            async submit(){
                let form_result = this.$refs.form.validate()
                let validate_input = false
                if (this.tab === 0){
                    if (this.input_method === 1) {
                        validate_input = this.$refs.invoice_form_1.validateInput()
                    }
                    else {
                        validate_input = true
                    }
                }
                else {
                    validate_input = this.$refs.invoice_form_2.validateInput()
                }
                if (!form_result || !validate_input) {
                    this.$root.vtoast.show({ 
                        color: this.theme_color,
                        message: `請檢查欄位是否填寫完整。`
                    })
                    return
                }

                if (this.tab === 0 && this.input_method === 0) {
                    console.log('open_scan')
                    this.$refs.invoice_scan.startScan()
                }
                else {


                    if (!validate_input) {
                        this.$root.vtoast.show({ 
                            color: this.theme_color,
                            message: `請檢查欄位是否填寫完整。`
                        })
                        return
                    }
                    console.log('send_2_backend')
                    console.log('validate_input:',validate_input)
                    let count_val = 0
                    if (this.value_method === 'cost') {
                        count_val = this.data.value
                    }
                    else {
                        this.data.items.forEach(function(item){
                            let q = parseInt(item.quantity)
                            let price = parseInt(item.per_price)
                            if (!isNaN(q) && !isNaN(price)) {
                                count_val += q * price 
                            }
                            
                        })
                    }

                    let params = {
                        "invoice_collector_id": this.$route.query.id,
                        "invoice_date": `${this.data.create_at} 00:00:00`,
                        "customer_name": this.data.name,
                        "customer_email": this.data.email,
                        "customer_id": `${this.data.customer_id}`,
                        "invoice_number": `${this.data.prefix}${this.data.number}`,
                        "sales_price": 0,
                        "total_price": count_val,
                        "buyer": "",
                        "vendor": "",
                        "memo": "",
                        "items": this.data.items
                    }
                    try {
                        let result = await apiSendInvoiceData(params)
                        console.log('result', result)
                        // this.$root.vtoast.show({ 
                        //     message: `登錄成功！`,
                        //     color: 'success'
                        // })
                        this.sendPixelEvent()
                        this.clearInput()
                        this.is_send_success = true
                    } catch (error) {
                        console.log('error', error)
                        this.is_send_success = false
                        if (error.includes('invoice had been saved')) {
                            this.send_message = `此張發票已經登錄。`
                        }
                        else if (error.includes('begin')) {
                            this.send_message = `發票格式錯誤。`
                            // this.$root.vtoast.show({ 
                            //     message: `發票格式錯誤。`
                            // })
                        }
                        else {
                            this.send_message = `原因: ${error}`
                        }
                    }

                    this.is_send = true
                    
                    
                }
            },
            clickOverlay(){
                console.log('click')
                if (!this.is_click) {
                    this.is_click = true
                    this.dialog = true
                }
                else {
                    this.is_click = false
                    this.dialog = false
                }
                
            },
            closeDialog(){
                this.is_click = false
                this.dialog = false
            },
            getIframeCallback(event){
                console.log('callback_event', event)

                // if (event.origin !== window.location.origin) {
                //     return
                // }

                const resp_data = event.data
                console.log('callback_data',resp_data)
                // const data = resp_data.data

                if (resp_data.action === 'change_style') {
                    this[resp_data.field] = resp_data.value
                    console.log(resp_data.field, this[resp_data.field])
                }
                else if (resp_data.action === 'login_callback') {
                    console.log('login_callback',)
                    let user_data = resp_data.data
                    if (user_data) {
                        this.data.name = user_data.name
                        this.data.email = user_data.email
                        this.data.customer_id = user_data.id
                        this.is_login = true
                        this.dialog = false
                    }
                }

                this.container_key += 1
                


            },
            requestUserInfo(is_redirect){
                let data = {
                    'url': window.location.href,
                    'feature': 'invoice_collector',
                    'action': 'login',
                    'is_redirect': is_redirect,
                    'container_id': this.container_id
                }
                parent.postMessage(data, '*');
                console.log('post', data)
            },
            async sendInvoce(params){
                let is_success = false
                try {
                    let result = await apiSendInvoice(params)
                    console.log('result', result)
                    // this.$root.vtoast.show({ 
                    //     message: `登錄成功！`,
                    //     color: 'success'
                    // })
                    
                    this.sendPixelEvent()
                    this.clearInput()
                    this.is_send_success = true
                    this.is_send = true
                } catch (error) {
                    console.log('error', error)
                    if (error.includes('invoice had been saved')) {
                        this.send_message = `此張發票已經登錄。`
                    }
                    else if (error.includes('begin')) {
                        this.send_message = `發票格式錯誤。`
                        // this.$root.vtoast.show({ 
                        //     message: `發票格式錯誤。`
                        // })
                    }
                    else {
                        this.send_message = `原因: ${error}`
                    }
                }
                return is_success
            },
            sendPixelEvent(){
                let event_name = ''
                if (this.pixel_event === 'Custom') {
                    event_name = this.custom_event
                }
                else {
                    event_name = this.pixel_event
                }
                let data = {
                    'container_id': this.container_id,
                    'url': window.location.href,
                    'feature': 'invoice_collector',
                    'action': 'send_pixel',
                    'data': {
                        'event': event_name
                    }
                }
                parent.postMessage(data, '*');
            },
            async scanCallback(data){
                console.log('scan_callback', data)

                if (this.$route.query.id === undefined) {
                    // this.$root.vtoast.show({ 
                    //     message: `無法取得。`
                    // })
                    return
                }
                let params = {
                    "left": data.left,
                    "right": data.right,
                    "collector_id": this.$route.query.id,
                    "customer_email": this.data.email,
                    "customer_name": this.data.name,
                    "customer_id": this.data.customer_id,
                    "memo": ""
                }
                let is_send_success = await this.sendInvoce(params)
                this.$refs.invoice_scan.submitCallback()
                this.is_send_success = is_send_success
                this.is_send = true
            },
            clearInput(){
                this.data.create_at = ''
                this.data.prefix = ''
                this.data.number = ''
                this.data.value = ''
                this.data.items =[
                    {
                        "quantity": "",
                        "name": "",
                        "per_price": ""
                    }
                ] 
                this.container_key += 1 
            },
            reDo(){
                this.is_send = false
                this.send_message = ''
                this.is_send_success = false
            }
        }
    }
</script>
<style scoped>
.collector-bg {
    /* background-color: rgb(248, 248, 248); */
    /* background-image: url(https://assets.fevercdn.com/picture-origin/production/info/promotions/612/20230725032721_64bf411922265.png); */
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    display: flex;
    justify-content: center;
}
.title-container {
    text-align: center;
    padding: 20px 0px;

}
.app-container {
    max-width: 960px;
    width: 100%;
    background-color: transparent !important;
    text-align: center;
}
.tab-container {
    display: inline-flex;
}
.title-container >>>  p{
    margin: 0px;
}

.invoice-input >>> input::-webkit-outer-spin-button,
.invoice-input >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.invoice-input >>> input[type=number] {
  -moz-appearance: textfield;
}

.invoice-title {
    font-size: 24px;
}
</style>